// extracted by mini-css-extract-plugin
module.exports = {"heroGraphic":"SunburstEmptyState-heroGraphic-2sYDI6","spin":"SunburstEmptyState-spin-2c_8C0"};